import axiosInstance from "./api";

const BASE_URL = "/api/models";

export const modelService = {
  list: async () => {
    const response = await axiosInstance.get(`${BASE_URL}/list`);
    return response?.data?.data ?? [];
  },

  getTrainingDataList: async (params = {}) => {
    const { excludes_tags, includes_tags, names, include_data = false } = params;
    const queryParams = new URLSearchParams();

    if (excludes_tags) queryParams.append('excludes_tags', excludes_tags);
    if (includes_tags) queryParams.append('includes_tags', includes_tags);
    if (names) queryParams.append('names', names);
    queryParams.append('include_data', include_data);

    const response = await axiosInstance.get(`${BASE_URL}/training_data/list?${queryParams}`);
    return response?.data?.data?.entries ?? [];
  },

  createTrainingData: async (trainingData) => {
    const response = await axiosInstance.post(
      `${BASE_URL}/training_data`,
      trainingData
    );
    return response?.data?.data;
  },

  getTrainingDataById: async (id) => {
    const response = await axiosInstance.get(`${BASE_URL}/training_data/id/${id}`);
    return response?.data?.data;
  },
  
  updateTrainingData: async (id, trainingData) => {
    const response = await axiosInstance.put(
      `${BASE_URL}/training_data/${id}`,
      trainingData
    );
    return response?.data?.data;
  },

  deleteTrainingData: async (id) => {
    const response = await axiosInstance.delete(
      `${BASE_URL}/training_data/${id}`
    );
    return response?.data?.data;
  },

  fineTuneModel: async (modelData, startProcess) => {
    const response = await axiosInstance.post(`${BASE_URL}/fine_tune`, modelData, {
      params: { start_process: startProcess }
    });
    return response?.data?.data;
  },

  getFineTuneById: async (id) => {
    const response = await axiosInstance.get(`${BASE_URL}/fine_tune/id/${id}`);
    return response?.data?.data;
  },

  getFineTuneList: async (params = {}) => {
    const { excludes_tags, includes_tags, names } = params;
    const queryParams = new URLSearchParams();

    if (excludes_tags) queryParams.append('excludes_tags', excludes_tags);
    if (includes_tags) queryParams.append('includes_tags', includes_tags);
    if (names) queryParams.append('names', names);

    const response = await axiosInstance.get(`${BASE_URL}/fine_tune/list?${queryParams}`);
    return response?.data?.data?.entries ?? [];
  },

  getFineTuneUploadId: async (id) => {
    const response = await axiosInstance.get(
      `${BASE_URL}/fine_tune/upload_id/${id}`
    );
    return response?.data?.data;
  },

  updateFineTunedModelData: async (id, modelData, startProcess) => {
    const response = await axiosInstance.put(`${BASE_URL}/fine_tune/${id}`, modelData, {
      params: { start_process: startProcess }
    });
    return response?.data?.data;
  },

  cancelFineTuneJob: async (id) => {
    const response = await axiosInstance.post(
      `${BASE_URL}/fine_tune/${id}/cancel`
    );
    return response?.data?.data;
  },

  deleteFineTunedModel: async (id) => {
    const response = await axiosInstance.delete(
      `${BASE_URL}/fine_tune/${id}`
    );
    return response?.data?.data;
  },
};

export default modelService;